<template>
	<div class="message-management-container">
		<div class="title-container">
			<h3>消息通知管理</h3>
			<div class="pulish-button-container">
				<el-button type="primary" @click="messagePulish">消息发布</el-button>
			</div>
		</div>
		<el-form :inline="true" :model="formInline">
			<el-form-item label="消息等级">
				<el-select v-model="formInline.level" placeholder="请选择消息等级" clearable="">
					<el-option label="普通消息" value="1"></el-option>
					<el-option label="重要消息" value="2"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-button @click="getAllMessageInfo">搜索</el-button>
			</el-form-item>
			<el-form-item>
				<el-button @click="clear">取消</el-button>
			</el-form-item>
		</el-form>
		<div>
			<el-table ref="tableRef" :data="formData" style="width: 100%">
				<el-table-column align="center" prop="title" label="标题"></el-table-column>
				<el-table-column align="center" prop="sendName" label="发布人"></el-table-column>
				<el-table-column align="center" prop='createTime' label="发布时间" sortable></el-table-column>
				<el-table-column align="center" label="消息等级">
					<template slot-scope="scope">
						{{scope.row.level==1?'普通':'重要'}}
					</template>
				</el-table-column>
				<el-table-column align="center" label="发布人数">
					<template slot-scope="scope">
						{{scope.row.num}}人
					</template>
				</el-table-column>
				<el-table-column align="center" label="操作" min-width="180">
					<template slot-scope="scope">
						<el-button  size="mini" @click="viewMessage(scope.row)">查看内容</el-button>
						<el-button  size="mini" @click="deleteMessageClick(scope)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination :current-page="formInline.currentPage" @current-change="handleCurrentChange" style="margin: 20px;0"
			 background layout="total,prev, pager, next" :total="totalNum">
			</el-pagination>
		</div>

		<div class="message-dialog">
			<el-dialog width="840px" title="消息列表" :visible.sync="dialogVisible" :close-on-click-modal="false"
			 :modal-append-to-body="false">
				<el-form :model="receiveItems" label-width="75px">
					<el-form-item label="标题">
						<el-input size="small" v-model="receiveItems.title"></el-input>
					</el-form-item>
					<el-form-item label="消息内容">
						<el-input type="textarea" :rows="5" v-model="receiveItems.content"></el-input>
					</el-form-item>
					<el-form-item label="文件">
						<el-upload multiple action="/api/admin/bdContract/uploadContract" :on-preview="uploadDown" :headers="headers"
						 :file-list="files" name="file">
					</el-upload>
					</el-form-item>
				</el-form>
				<el-table :data="receiveItems.getMessagesUsersResList">
					<el-table-column prop="receiverName" label="接收人" align="center"></el-table-column>
					<el-table-column prop="createTime" label="接收时间" align="center">
						<template slot-scope="scope">
							{{scope.row.createTime.split("T")[0]}}
						</template>
					</el-table-column>
					<el-table-column label="已读时间" align="center">
						<template slot-scope="scope">
							{{scope.row.updateTime==null?'无':scope.row.updateTime.split("T")[0]}}
						</template>
					</el-table-column>
					<el-table-column label="消息状态" align="center">
						<template slot-scope="scope">
							{{scope.row.status==1?'未读':'已读'}}
						</template>
					</el-table-column>
				</el-table>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import downloadFile from '../../assets/js/downloadFile.js'
	// import formatting from "@/assets/js/formatting"
	export default {
		data() {
			return {
				headers: {
					Authorization: localStorage.access_token
				},
				messageTableViewData: [], //信息表格数据
				currentRowData: {}, //当前行数据
				dialogVisible: false,
				currentPage: 1,
				formInline: {
					pageSize: 10,
					currentPage: 1,
					level: ''
				},
				files: [],
				totalNum: null,
				formData: [],
				pageSize: 10, //当前页显示多少条
				pageCount: 1, //总页数
				receiveItems: [], //接收者列表
			}
		},
		computed: {
			// filterTableViewData(){
			//     return this.messageTableViewData.slice((this.currentPage-1) * this.pageSize, this.currentPage * this.pageSize);
			// },
		},
		methods: {
			clear() {
				this.formInline.level = ''
				this.getAllMessageInfo()
			},
			messagePulish() { //跳转消息发布页面
				this.$router.push({
					name: '发送消息'
				});
			},

			formatterStatus(row) { //格式化已读和未读状态
				if (row.status == 0) {
					return '未读';
				} else {
					return '已读';
				}
			},
			uploadDown(obj) {
				console.log(obj)
				this.$confirm('确定下载该文件吗', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(res => {
					downloadFile(obj);
					this.$message({
						type: 'success',
						message: '下载成功!'
					});
				}).catch(err => {
					this.$message({
						type: 'success',
						message: '取消下载!'
					});
				})

			},
			formatterTeamName(row) { //格式化队伍名称
				if (row.teamName == null) {
					return '未加入队伍';
				} else {
					return row.teamName;
				}
			},
			formatterSportsType(row) {
				if (row.sportsType == null) {
					return '无';
				} else {
					return row.sportsType;
				}
			},
			tableCellClick(row) { //当前行点击
				this.currentRowData = row;
			},
			viewMessage(row) { //查看详情
				console.log(row)
				this.receiveItems = row;
				this.dialogVisible = true;
				if (this.receiveItems.files != null) {
					let newFiles = [];
					this.receiveItems.files.forEach((item) => {
						newFiles.push({
							name: item.name,
							url: item.url
						});
					})
					this.files = newFiles;
				}
			},
			handleCurrentChange(num) { //当前页面变更
				this.formInline.currentPage = num;
				this.getAllMessageInfo();
			},
			handleDeleteAfterData(id) { //处理删除之后的数据
				for (let i = 0; i < this.messageTableViewData.length; i++) {
					if (this.messageTableViewData[i].id == id) {
						this.messageTableViewData.splice(i, 1);
						break;
					}
				}
				this.messageTotal = this.messageTableViewData.length;
			},
			deleteMessageClick(scope) { //删除消息
				let id = scope.row.messageId
				this.$confirm('是否将此条通知消息删除?', '删除提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get(`/api/message/deleteMessage?messageId=${id}`).then(res => {
						if (res.data.code == 0) {
							this.getAllMessageInfo()
							this.$message.success(res.data.message)
						} else {
							this.$message.error(res.data.message);
						}
					}, reject => {
						console.error('信息删除失败', reject.response.data.message);
					});
				})
			},
			getAllMessageInfo() {
				this.$http.post('/api/message/queryMessage', {
					...this.formInline
				}).then(res => {
					if (res.data.code == 0) {
						this.formData = res.data.data.items
						this.totalNum = res.data.data.totalNum;
						this.formData.forEach(val => {
							val.createTime = val.createTime.split("T")[0]
						})
					} else {
						// this.$message.error(res.data.message);
					}
				}, reject => {
					console.error('公告获取失败', reject.response.data.message);
				});
			}
		},
		created() {
			this.getAllMessageInfo();
		}
	}
</script>

<style scoped>
	.message-management-container {
		width: 100%;
		padding: 5px 20px;
	}

	.title-container {
		margin: 15px auto;
		display: flex;
		align-items: center;
	}

	.pulish-button-container {
		margin-left: auto;
	}

	.page-container {
		text-align: center;
		margin-top: 15px;
	}
</style>
